<template lang="pug">
#services
  section.section.page-section.top-section
    .columns
      #service-sidebar-column.column.is-one-quarter.is-hidden-mobile
        services-sidebar(:config="sidebarConfig")
      #service-content-column.column.is-three-quarters
        services-search
        services-filter-bar

        b-tabs.service-tabs(
          v-model="settings.tab"
          position="is-centered"
          :animated="false"
          @change="changeTab"
        )
          b-tab-item(label="Sermons")
            episodes-tab(v-if="!settings.loading")
          b-tab-item(label="Series")
            collections-tab(v-if="!settings.loading")
          b-tab-item(label="Speakers")
            speakers-tab(v-if="!settings.loading")
  //- b-modal(:active.sync="modals.filter" has-modal-card width="960")
  //-   episode-filters-modal
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { SEARCH } from '@/utils/http';
import CollectionsTab from '@/components/collections/CollectionsTab.vue';
import EpisodeListItem from '@/components/episodes/EpisodeListItem.vue';
import EpisodeTypeahead from '@/components/episodes/EpisodeTypeahead.vue';
import EpisodesTab from '@/components/episodes/EpisodesTab.vue';
import ServicesFilterBar from '@/components/ServicesFilterBar.vue';
import ServicesSearch from '@/components/ServicesSearch.vue';
import ServicesSidebar from '@/components/episodes/ServicesSidebar.vue';
import SpeakersTab from '@/components/speakers/SpeakersTab.vue';
import Spinner from '@/components/Spinner.vue';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';

export default {
  name: 'services-page',
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const routes = [
        'episode',
        'collection',
        'speaker',
      ];
      if (from && !routes.includes(from.name)) {
        vm.$store.commit(mutationTypes.SET_EPISODES_AGGREGATIONS, {});
        vm.$store.commit(mutationTypes.SET_EPISODES, []);
        vm.$store.dispatch(actionTypes.DO_GET_CHANNELS, { filter: 'services' })
          .then(() => {
            vm.$store.commit(mutationTypes.SET_EPISODE_COLLECTIONS, []);
            vm.$store.commit(mutationTypes.SET_SERVICES_REFRESH, true);
          });
      }
    });
  },
  components: {
    CollectionsTab,
    EpisodeListItem,
    EpisodeTypeahead,
    EpisodesTab,
    ServicesFilterBar,
    ServicesSearch,
    ServicesSidebar,
    SpeakersTab,
    Spinner,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      aggregationsDefintion: getterTypes.GET_SERVICES_AGGREGATIONS,
      aggregations: getterTypes.GET_EPISODES_AGGREGATIONS,
      channels: getterTypes.GET_CHANNELS,
      episodes: getterTypes.GET_EPISODES,
      filters: getterTypes.GET_SERVICES_FILTERS,
      refresh: getterTypes.GET_SERVICES_REFRESH,
      page: getterTypes.GET_PAGE,
    }),
    channelIds() {
      if (!this.channels) return [];
      return _.map(this.channels, 'id');
    },
    esQuery() {
      const today = moment().format('YYYY-MM-DD');
      return {
        size: 0,
        aggs: {
          by_account: {
            filter: {
              bool: {
                must: [
                  { match: { account_id: this.account.id } },
                  { terms: { channel_ids: this.channelIds } },
                  { match: { is_published: true } },
                  { range: { pub_date: { lte: today } } },
                ],
              },
            },
            aggs: this.aggregationsDefintion,
          },
        },
      };
    },
    isMobile() {
      return window.innerWidth <= 769;
    },
    pageQuery() {
      const payload = {
        channels: _.map(this.filters.channels, 'id').join(','),
        speakers: _.map(this.filters.speakers, 'id').join(','),
        tab: this.tabs[this.settings.tab],
        tags: _.map(this.filters.tags, 'id').join(','),
        years: _.map(this.filters.years, 'id').join(','),
        query: this.filters.query,
      };
      return _.pickBy(payload, _.identity);
    },
  },
  async created() {
    if (this.channels.length === 0) this.settings.loading = true;
    await this.$store.dispatch(actionTypes.DO_GET_CHANNELS, { filter: 'services' });
    if (_.isEmpty(this.aggregations)) {
      this.settings.loading = true;
      const { data } = await SEARCH.post('/doxa_episodes/_search', this.esQuery);
      this.$store.commit(mutationTypes.SET_EPISODES_AGGREGATIONS, data.aggregations);
    }
    this.setupView();
    this.settings.loading = false;
    return Promise.resolve();
  },
  data() {
    return {
      bottom: false,
      modals: {
        filter: false,
      },
      settings: {
        loading: false,
        tab: 0,
      },
      sidebarConfig: {
        channels: true,
        speakers: true,
        years: true,
        tags: true,
      },
      tabs: [
        'sermons',
        'series',
        'speakers',
      ],
    };
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollHandler);
  },
  methods: {
    changeTab(tab) {
      this.$store.commit(mutationTypes.SET_SERVICES_MODE, this.tabs[tab]);
      this.pushQueryParams();
    },
    pushQueryParams() {
      if (!_.isEmpty(this.pageQuery)) {
        this.$router.push({
          name: 'services',
          query: this.pageQuery,
        });
      }
    },
    scrollHandler() {
      const y = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const adjustedHeight = pageHeight - 300;
      const bottomOfPage = visible + y >= adjustedHeight;
      this.bottom = bottomOfPage || adjustedHeight < visible;
    },
    set(val, key) {
      if (val) {
        this.$store.commit(mutationTypes.SET_SERVICES_FILTER, {
          key,
          val,
        });
      } else {
        this.$store.commit(mutationTypes.SET_SERVICES_FILTER, {
          key,
          val: null,
        });
        this.$store.commit(mutationTypes.SET_SERVICES_REFRESH, true);
      }
    },
    setupView() {
      if (this.$route.query.tab) {
        const { tab } = this.$route.query;
        this.settings.tab = _.indexOf(this.tabs, tab);
        this.$store.commit(mutationTypes.SET_SERVICES_MODE, tab);
      }
      if (this.$route.query.query) {
        this.$store.commit(mutationTypes.SET_SERVICES_FILTER, {
          key: 'query',
          val: this.$route.query.query,
        });
        this.$store.commit(mutationTypes.SET_SERVICES_FILTER, {
          key: 'displayQuery',
          val: true,
        });
      }
      const keys = [
        'channels',
        'speakers',
        'tags',
        'years',
      ];
      keys.forEach((key) => {
        if (this.$route.query[key]) {
          let ids = this.$route.query[key].split(',');
          const getter = `GET_EPISODES_AGGREGATIONS_BY_${key.toUpperCase().slice(0, -1)}`;
          const objects = this.$store.getters[getterTypes[getter]];
          const val = _.filter(objects, (obj) => {
            if (key === 'years') {
              ids = _.map(ids, id => parseInt(id, 10));
            }
            return ids.includes(obj.id);
          });
          this.$store.commit(mutationTypes.SET_SERVICES_FILTER, {
            key,
            val,
          });
        }
      });
    },
    unsetFilter(filter) {
      this.filters[filter] = 'all';
    },
    unsetFilters() {
      this.selectedFilters.forEach((selected) => {
        this.filters[selected.filter] = 'all';
      });
    },
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandler);
  },
  watch: {
    bottom(val) {
      if (val) {
        this.$store.commit(mutationTypes.SET_SERVICES_NEXT_PAGE, true);
      }
    },
    refresh(val) {
      if (val && !this.settings.loading) {
        this.pushQueryParams();
      } else if (!val) {
        this.settings.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
#services {
  min-height: 100vh;
  section.section {
    padding-bottom: 0;
    min-height: 100%;
  }
  #service-sidebar-column {
    padding-right: 0;
    min-height: 100%;
  }
  #service-content-column {
    padding-left: 0;
    min-height: 100%;
    background-color: $body-background;
    .services-search, .services-filter-bar {
      background-color: $white;
    }
    .b-tabs {
      margin-top: 0;
      nav.tabs {
        padding-top: 1rem;
        background-color: $white;
      }
    }
    .service-tabs {
      .tabs {
        ul {
          border-bottom-color: #eaeaea;
        }
      }
      .tab-content {
        min-height: 80vh;
      }
    }
  }
}
@media (max-width: $tablet) {
  #services {
    .columns {
      margin: 0;
      .column {
        padding: 0;
      }
    }
    .service-tabs {
      .tab-content {
        padding-left: 0;
        padding-right: 0;
        .episode-list-item, .collection-list-item {
          margin-bottom: 1.5rem;
          .card-content {
            border-left: 0;
            border-right: 0;
          }
        }
      }
    }
  }
}
</style>

<style theme="ffc" lang="scss">
#services {
  #service-content-column {
    background-color: $white-ter;
  }
}
</style>

<style theme="cwo" lang="scss">
#service-sidebar-column {
  padding-bottom: 0;
  .service-tabs {
    .tabs {
      a {
        font-family: $heading-font;
        font-weight: 500;
      }
    }
  }
}
</style>
